import React from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '../../../Icons/24x24/Edit';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { BiEventType } from '../../../biLogger';
export var EditButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(ActionBarButton, { tooltip: t('actionbar.edit'), onClick: function () {
            onClick({ deviation: deviation, fromDeviationPage: true });
        }, isEditAction: true, biData: {
            evid: BiEventType.DEVIATION_EDIT_CLICK,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
        } },
        React.createElement(ActionBarIcon, { icon: EditIcon })));
};
EditButton.displayName = 'EditButton';
export default EditButton;
//# sourceMappingURL=EditButton.js.map